// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "global." + chunkId + "." + {"301":"e2d04341ad605f71c8d0","665":"5bc4257c5a43a22f4eed"}[chunkId] + ".js";
};